import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../style/CouponDetail.css';
import coupons from '../data/coupons.json';
import ad6 from '../assets/ad6.png';
import ad7 from '../assets/havells.webp'

const CouponDetail = () => {
  const { code } = useParams();
  const [coupon, setCoupon] = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false); 
  const navigate = useNavigate();

  useEffect(() => {
    const foundCoupon = coupons.find(c => c.code === code);
    if (foundCoupon) {
      setCoupon(foundCoupon);
    }
    setLoading(false);
  }, [code]);

  if (loading) {
    return <p>Loading coupon details...</p>;
  }

  if (!coupon) {
    return <p>Coupon not found.</p>;
  }

  const mainImageSrc = coupon.image ? require(`../assets/${coupon.image}`) : null;
  const logoImageSrc = coupon.logo ? require(`../assets/${coupon.logo}`) : null;

  // Copy function
  const handleCopy = () => {
    navigator.clipboard.writeText(coupon.code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
  };const handleShare = () => {
  const currentUrl = window.location.href.split('?')[0]; // Remove any query params like ?coupon=...

  if (navigator.share) {
    navigator
      .share({
        title: document.title,
        url: currentUrl,
      })
      .then(() => console.log('Shared successfully'))
      .catch((error) => console.error('Error sharing:', error));
  } else {
    // Fallback: copy URL to clipboard
    navigator.clipboard.writeText(currentUrl);
    alert('Link copied to clipboard');
  }
};
  return (
    <>
    <div className="ads">
<a href="https://www.lufthansa.com/in/en/homepage?utm_source=zigwheel_display_cpm&utm_medium=display&utm_campaign=2025_in_lh_allegris_mid_funnel_campaign2&utm_content=bc2&dclid=CNTC-6ynl48DFUKkSwUdi84Qkg&gad_source=7&xctg=1629&et_uk=5b5a278976684cdfbecb7fd63ee285ff" className="ads-banner">
          <img src ={ad6}/>
          </a>     
    </div>
    <div className="coupon-detail-container">
      <div className="top-bar">
        <div className="back-button-container" onClick={() => navigate(-1)}>
          <span>Go Back</span>
        </div>
        <button className="share-button" onClick={handleShare}>
          <i className="fas fa-share-alt"></i> Share
          </button>

      </div>

      <div className="coupon-main-section">
        <div className="coupon-info-left">
          <div className="coupon-header">
            <h1 className="coupon-title">{coupon.title}</h1>
            {logoImageSrc && (
              <img
                src={logoImageSrc}
                alt={`${coupon.title} logo`}
                className="coupon-logo"
              />
            )}
          </div>
          <p className="coupon-description">
            {coupon.description}
          </p>

          <div className="coupon-code-box">
            <span className="coupon-code">{coupon.code}</span>
            <button className="copy-button" onClick={handleCopy}>
              {copied ? 'COPIED!' : 'COPY CODE'}
            </button>
          </div>

          {coupon.websiteUrl && coupon.storeName && (
            <a
              href={coupon.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="go-to-website"
            >
              &rarr; Go To {coupon.storeName} Website
            </a>
          )}

         
        </div>

        <div className="coupon-info-right">
          {mainImageSrc && (
            <img
              src={mainImageSrc}
              alt={`${coupon.title} offer`}
              className="coupon-right-image"
            />
          )}
          <ul className="coupon-details-list">
            {coupon.rule1 && <li>1. {coupon.rule1}</li>}
            {coupon.rule2 && <li>2. {coupon.rule2}</li>}
            {coupon.rule3 && <li>3. {coupon.rule3}</li>}
          </ul>
        </div>
      </div>
      <div>
        <a href="https://havells.com/home-advisor?utm_source=xenium&utm_medium=affiliate&utm_campaign=Monthly_HomeAdvisor_JFM" className="ad-banner">
          <img src ={ad7}/>
          </a>        
      </div>
    </div>
    </>
  );
};

export default CouponDetail;
